module.exports = __webpack_public_path__ + "media/images/analytics_dashboard-7482ada93cd6a409ce31eb9496211cc8.png";